// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!../../../../../../../../../node_modules/less-loader/dist/cjs.js!./base/PrizeFundCampaign.base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NP3ztd6P7UaUXUdrjMp3 {
  font-size: 74px;
}
.NP3ztd6P7UaUXUdrjMp3[data-variant='card'] {
  font-size: 66px;
}
.NP3ztd6P7UaUXUdrjMp3[data-variant='card'] .MCdT6kGbJmhptZ9kt6WA {
  font-size: 20px;
}
.MCdT6kGbJmhptZ9kt6WA {
  font-size: 30px;
  margin-left: 2px;
}
.btRujArivrBzxwxahj1p {
}
.Ghbu586_LVeCLhHZVTnT {
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .NP3ztd6P7UaUXUdrjMp3 {
    font-size: 62px;
  }
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] {
    font-size: 44px;
  }
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] .MCdT6kGbJmhptZ9kt6WA {
    font-size: 13px;
  }
  .MCdT6kGbJmhptZ9kt6WA {
    font-size: 20px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] {
    font-size: 36px;
  }
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] .MCdT6kGbJmhptZ9kt6WA {
    font-size: 11px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] {
    font-size: 36px;
  }
  .NP3ztd6P7UaUXUdrjMp3[data-variant='card'] .MCdT6kGbJmhptZ9kt6WA {
    font-size: 11px;
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/css/MultiViewPrizeFundCampaign.module.css"],"names":[],"mappings":"AAAA;EAEE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EAEE,eAAe;EACf,gBAAgB;AAClB;AACA;AAEA;AACA;AAEA;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AAAA;AAAA;AAAA","sourcesContent":[".prizeContainer {\n  composes: prizeContainer from './base/PrizeFundCampaign.base.module.css';\n  font-size: 74px;\n}\n.prizeContainer[data-variant='card'] {\n  font-size: 66px;\n}\n.prizeContainer[data-variant='card'] .currency {\n  font-size: 20px;\n}\n.currency {\n  composes: currency from './base/PrizeFundCampaign.base.module.css';\n  font-size: 30px;\n  margin-left: 2px;\n}\n.prizeTextStyle {\n  composes: prizeTextStyle from './base/PrizeFundCampaign.base.module.css';\n}\n.prizeTextStyleAmount {\n  composes: prizeTextStyleAmount from './base/PrizeFundCampaign.base.module.css';\n}\n@media (--campaign-mobile) {\n  .prizeContainer {\n    font-size: 62px;\n  }\n  .prizeContainer[data-variant='card'] {\n    font-size: 44px;\n  }\n  .prizeContainer[data-variant='card'] .currency {\n    font-size: 13px;\n  }\n  .currency {\n    font-size: 20px;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  .prizeContainer[data-variant='card'] {\n    font-size: 36px;\n  }\n  .prizeContainer[data-variant='card'] .currency {\n    font-size: 11px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"prizeContainer": `NP3ztd6P7UaUXUdrjMp3 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeContainer"]}`,
	"currency": `MCdT6kGbJmhptZ9kt6WA ${___CSS_LOADER_ICSS_IMPORT_0___.locals["currency"]}`,
	"prizeTextStyle": `btRujArivrBzxwxahj1p ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeTextStyle"]}`,
	"prizeTextStyleAmount": `Ghbu586_LVeCLhHZVTnT ${___CSS_LOADER_ICSS_IMPORT_0___.locals["prizeTextStyleAmount"]}`
};
export default ___CSS_LOADER_EXPORT___;
